module.exports = __webpack_public_path__ + "static/img/ssje.7fb69475.png";